/* eslint-disable import/prefer-default-export */
export enum WebDemoType {
  NA,
  NDC,
  STA,
}
